
let resumeData = {
  "imagebaseurl":"https://reynaldoserantes.com/",
  "name": "Reynaldo Serantes",
  "tagLine": "designer • web development • adventure seeker • devops",
  "role": "Developer",
  "emailid": "Your emailid",
  "skypeid": "Your skypeid",
  "roleDescription": " I like dabbling in various parts of frontend development and I love to learn about new technologies, write technical articles or simply play games in my free time.",
  "socialLinks":[
      {
        "name":"linkedin",
        "url":"https://www.linkedin.com/in/rey-serantes-b3bbb57",
        "className":"fa fa-linkedin"
      },
      {
        "name":"github",
        "url":"https://github.com/r3ys3r",
        "className":"fa fa-github"
      }
    ],
  "aboutme":[
    {
      "url":"images/profilepic.jpg",
    "sectionTitle":"About Me",
    "bio":"Rey started working for Northwestern in the Fall of 2014 after many years in the advertising world working as a Web Designer. During his time at Alumni Relations, Rey has a been a key member of his team working on a variety of web projects including new responsive email templates for ARD-wide use, Pioneering ARD’s web presence for annual #CATSGiveBack campaign on Giving Tuesday and redesigning the Northwestern Alumni Association Annual Report. He’s been able to build relationships across the NU Developer community by attending the monthly DEVIT meetings where other developers showcase some of the newest techniques in the programming world.",
    "name":"Reynaldo Serantes"
  }
  ],
  "education":[
    {
      "UniversityName":"International Academy of Design and Technology",
      "role":"Bachelor's in Fine Art | Web Design and Multimedia Development",
      "YearOfStart":"2004",
      "YearOfPassing":"2007",
      "Achievements":""
    }
  ],
  "work":[
    {
      "CompanyName":"Jellyvision",
      "role":"Site Reliability Engineer II | Configuration & Publishing",
      "MonthOfStart":"6",
      "YearOfStart":"2021",
      "ifCurrent":"current",
      "Achievements":"I'm an embedded SRE on our Configuration and Publishing team. My responsiblities revolve around maintain delivery pipelines, ensuring that we're following proper CICD practices and that the team is supported in the event of an incident. Additionally I'm also a part of a larger centralized SRE team that manage high-level intiatives across the organization. Some of these initiatives are included: migrating repositories to Gitlab, standardize our entire CICD deployment process and standard IT housekeeping.\n",
      "keyPoints":"\n• Create and Maintain delivery pipelines for my designated application team \n • Implement new features for infrastructure to maintain stability and ensure proper patching\n • Set up monitoring and alerting to notify team members in the event of failures\n• Standardizing processes to ensure easier onboarding for new team members"
    },
    {
      "CompanyName":"",
      "role":"Site Reliability Engineer I | Shared Tools",
      "MonthOfStart":"3",
      "YearOfStart":"2019",
      "MonthOfLeaving":"6",
      "YearOfLeaving":"/2021",
      "Achievements":"I work on the Shared Tools team where we create/maintain libraries of tools for deployments, ensure uptime on all applications and remediate during production outages. I have worked on initiatives to automate more of our workloads, standardize how our resources are deployed across our environments and interfacing with many of the application teams when needed. Since starting at Jellyvision I've been exposed to many new technologies that I've had to learn on the go such as Terraform, groovy and Go. In addition I've gained a great amount of knowledge about networking and how to integrate with a variety of applications both internal and external facing.\n",
      "keyPoints":"\n• Creating standards across all applications managed by the Shared Tools team to enhance the engineers experience and to deploy faster.\n • Implementing tools for the organization to use."
    },
    {
      "CompanyName":"Northwestern University",
      "role":"Developer | NUIT Administrative Systems - ADEA",
      "MonthOfStart":"1",
      "YearOfStart":"2017",
      "MonthOfLeaving":"3",
      "YearOfLeaving":"/2019",
      "Achievements":"Develop code for the administrative systems used by Northwestern University Alumni. Additionally I've played a critical role for the following projects: Northwestern Alumni Association Website Redesign and Build, Northwestern University's Identity Provider implementation that sits in front of many NU login portals, Developing a proof of concept for a Universal Event Calendar that will be used by the Alumni Association.In addition I support multiple support rotations dealing with our data syncs and our CICD deployment system which pushes all code updates into all of our environments."
    },
    {
      "CompanyName":"Northwestern University",
      "role":"Web Developer | Alumni Relations and Development",
      "MonthOfStart":"8",
      "YearOfStart":"2014",
      "MonthOfLeaving":"12",
      "YearOfLeaving":"/2016",
      "Achievements":"Maintain all sites related to the Alumni Association as well as their major giving sites. In addition to those sites I also manage other web entities related to the university including the Northwestern Women's Board and the Northwestern Learning for Life sites. I also manage email template creation for the Alumni Association and compile web reporting to the many teams that make up the organization."
    },
  {
    "CompanyName":"Jacobs Agency",
    "role":"Web Designer | Production Designer",
    "MonthOfStart":"9",
    "YearOfStart":"2010",
    "MonthOfLeaving":"7",
    "YearOfLeaving":"/2014",
    "Achievements":"I have a wide range of responsibilities at Jacobs Agency. Most of the time my main focus is to handle web projects ranging from simple landing pages to dynamic websites. In addition to the web work I work an many other print related projects with the creative team. I've been a part of many creative brainstorms and creative pitches during my time here. One unique project that I was brought on to assist with was an office rejuvenation project. Myself and one of the other Art Directors painted several murals in the office space. I was very honored to be asked to be a part of this project for many reasons but the major reason is that they showed a great deal of trust in me. They left the office with blank walls and returned to beautiful works of art."
  },
  {
  "CompanyName":"Encyclopedia Britannica",
  "role":"Web | Graphic Designer",
  "MonthOfStart":"12",
  "YearOfStart":"2009",
  "MonthOfLeaving":"9",
  "YearOfLeaving":"/2010",
  "Achievements":"Designed and coded the company site for the international market. Created several collateral pieces that were used by the sales teams abroad. Coordinated with the marketing department to create e-newsletters and other marketing pieces."
},
{
"CompanyName":"Point B Communications",
"role":"Production Designer",
"MonthOfStart":"10",
"YearOfStart":"2007",
"MonthOfLeaving":"1",
"YearOfLeaving":"/2009",
"Achievements":"As a Production Artists my main focus was to prepare all layouts for prepress and to handle the delivery of those layouts. The work ranged from simple ads to complex brochures. In addition to print work I also handled many of interactive projects that were assigned to me."
},
  {
    "CompanyName":"Feeding America",
    "role":"Graphic Design Intern",
    "MonthOfStart":"10",
    "YearOfStart":"2006",
    "MonthOfLeaving":"6",
    "YearOfLeaving":"/2007",
    "Achievements":"I was the Graphic Design Intern. I worked alongside the company designer. Assisted him with an assortment of work. Ranging from the company annual report to conference collateral material. When these collateral pieces were printed I would go with the Company designer to see how the proofing system worked as well as understanding dot separation."
  }
],
  "certifications":[
    {
      "CertName":"Amazon Web Services - Certified Developer",
      "dicipline":"Associate",
      "YearOfCompletion":"2018"
    }
  ],
  "skillsDescription":"Your skills here",
  "skills":[
    {
      "skillname":"HTML5"
    },
    {
      "skillname":"CSS"
    },
    {
      "skillname":"Reactjs"
    },
    {
      "skillname":"AWS"
    },
    {
      "skillname":"PHP"
    }
  ]
  ,
  "portfolio":[
    {
      "modalID":"#modal-O1",
      "name":"Northwestern Alumni Association Website",
      "description":"Web Site",
      "imgurl":"images/portfolio/coffee.jpg",
      "tags":"Rebranding, Web Design, Development"
    },
    {
      "modalID":"#modal-O2",
      "name":"Northwestern University Women's Board",
      "description":"Website",
      "imgurl":"images/portfolio/girl.jpg",
      "tags":"Rebranding, Web Design, Development"
    },
    {
      "modalID":"#modal-O3",
      "name":"Spoken | A Cafe",
      "description":"Website",
      "imgurl":"images/portfolio/spoken.png",
      "tags":"Rebranding, Web Design & Development"
    },
    {
      "modalID":"#modal-O4",
      "name":"Identity Provider Authentication",
      "description":"Auth0",
      "imgurl":"images/portfolio/console.jpg",
      "tags":"Development"
    }
  ]
}

export default resumeData



// WEBPACK FOOTER //
// ./src/resumeData.js